import React from 'react';
import PropTypes from 'prop-types';
import { PopupToggler } from '../../blocks/PopupToggler';
import { MoreActionsIcon } from '../../icons/MoreActionsIcon';
import styles from './ProductsFeedsTable.module.scss';

export function ProductsFeedRowAdditionalInfo({ row }) {
  return (
    <PopupToggler icon={<MoreActionsIcon />} title="Additional Information">
      <ul className={styles.additionalInformation}>
        <li>
          <strong>Process Type:</strong> {row.source}
        </li>
      </ul>
    </PopupToggler>
  );
}

ProductsFeedRowAdditionalInfo.propTypes = {
  row: PropTypes.shape({
    source: PropTypes.string.isRequired,
  }).isRequired,
};
